const upDownArrow = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 9C12.1908 9 12.3817 9.06358 12.5271 9.19009L16.4002 12.5606C16.7171 12.8365 16.7171 13.3288 16.4002 13.6047C16.1397 13.8313 15.752 13.8313 15.4916 13.6047L12 10.5661L8.5084 13.6047C8.24796 13.8313 7.86029 13.8313 7.59984 13.6047C7.28288 13.3288 7.28288 12.8365 7.59984 12.5606L11.4729 9.19009C11.6183 9.06358 11.8092 9 12 9Z" fill="#979797"/>
</svg>
`;

export default upDownArrow;
